import { flushSync } from "react-dom";

/**
 * Wraps a DOM-mutating callback (typically a react-router `navigate()` call)
 * in a browser View Transition, so ordinary page-to-page navigation (nav
 * rail, breadcrumbs) gets a soft cross-fade instead of an instant snap —
 * the same underlying API the dashboard cards' maximise/minimise morph
 * already uses (see `summary-cards.tsx`/`runs.tsx`/etc.), just applied to
 * plain navigation instead of a named shared-element transition.
 *
 * The crossfade itself is defined once, globally, in `tokens.css` as the
 * default `::view-transition-*(root)` animation — every
 * `document.startViewTransition()` call in the app gets it automatically
 * unless it opts into something else (theme switches add a `theme-transition`
 * class for their own circular-reveal keyframe; see tokens.css). No
 * `prefers-reduced-motion` check needed here either — that CSS disables the
 * animation under that media query, so `document.startViewTransition` still
 * runs, it just animates nothing.
 */
export function runViewTransition(callback: () => void): void {
  if (!document.startViewTransition) {
    callback();
    return;
  }

  document.startViewTransition(() => flushSync(callback));
}
